// source: no/jotta/openapi/wopi.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.no.jotta.openapi.GetLinksRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.GetLinksResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner', null, global);
goog.exportSymbol('proto.no.jotta.openapi.GetLinksResponse.Links', null, global);
goog.exportSymbol('proto.no.jotta.openapi.GetLinksResponse.ResultCase', null, global);
goog.exportSymbol('proto.no.jotta.openapi.UpdateWopiConsentRequest', null, global);
goog.exportSymbol('proto.no.jotta.openapi.UpdateWopiConsentResponse', null, global);
goog.exportSymbol('proto.no.jotta.openapi.WopiActionType', null, global);
goog.exportSymbol('proto.no.jotta.openapi.WopiConsent', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.UpdateWopiConsentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.UpdateWopiConsentRequest.displayName = 'proto.no.jotta.openapi.UpdateWopiConsentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.UpdateWopiConsentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.UpdateWopiConsentResponse.displayName = 'proto.no.jotta.openapi.UpdateWopiConsentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.GetLinksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.GetLinksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.GetLinksRequest.displayName = 'proto.no.jotta.openapi.GetLinksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.GetLinksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.no.jotta.openapi.GetLinksResponse.oneofGroups_);
};
goog.inherits(proto.no.jotta.openapi.GetLinksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.GetLinksResponse.displayName = 'proto.no.jotta.openapi.GetLinksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.GetLinksResponse.Links = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.GetLinksResponse.Links, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.GetLinksResponse.Links.displayName = 'proto.no.jotta.openapi.GetLinksResponse.Links';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.displayName = 'proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.UpdateWopiConsentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    consent: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.UpdateWopiConsentRequest}
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.UpdateWopiConsentRequest;
  return proto.no.jotta.openapi.UpdateWopiConsentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.UpdateWopiConsentRequest}
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.no.jotta.openapi.WopiConsent} */ (reader.readEnum());
      msg.setConsent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.UpdateWopiConsentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConsent();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional WopiConsent consent = 1;
 * @return {!proto.no.jotta.openapi.WopiConsent}
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.prototype.getConsent = function() {
  return /** @type {!proto.no.jotta.openapi.WopiConsent} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.no.jotta.openapi.WopiConsent} value
 * @return {!proto.no.jotta.openapi.UpdateWopiConsentRequest} returns this
 */
proto.no.jotta.openapi.UpdateWopiConsentRequest.prototype.setConsent = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.UpdateWopiConsentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.UpdateWopiConsentResponse}
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.UpdateWopiConsentResponse;
  return proto.no.jotta.openapi.UpdateWopiConsentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.UpdateWopiConsentResponse}
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.UpdateWopiConsentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.UpdateWopiConsentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.UpdateWopiConsentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.GetLinksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.GetLinksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    actionType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    language: jspb.Message.getFieldWithDefault(msg, 3, ""),
    viewLink: jspb.Message.getFieldWithDefault(msg, 5, ""),
    editLink: jspb.Message.getFieldWithDefault(msg, 6, ""),
    folderLink: jspb.Message.getFieldWithDefault(msg, 7, ""),
    downloadLink: jspb.Message.getFieldWithDefault(msg, 8, ""),
    closeLink: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.GetLinksRequest}
 */
proto.no.jotta.openapi.GetLinksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.GetLinksRequest;
  return proto.no.jotta.openapi.GetLinksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.GetLinksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.GetLinksRequest}
 */
proto.no.jotta.openapi.GetLinksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {!proto.no.jotta.openapi.WopiActionType} */ (reader.readEnum());
      msg.setActionType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setViewLink(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEditLink(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderLink(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadLink(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCloseLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.GetLinksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.GetLinksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActionType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getViewLink();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEditLink();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFolderLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDownloadLink();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCloseLink();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WopiActionType action_type = 2;
 * @return {!proto.no.jotta.openapi.WopiActionType}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getActionType = function() {
  return /** @type {!proto.no.jotta.openapi.WopiActionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.no.jotta.openapi.WopiActionType} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setActionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string language = 3;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string view_link = 5;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getViewLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setViewLink = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string edit_link = 6;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getEditLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setEditLink = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string folder_link = 7;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getFolderLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setFolderLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string download_link = 8;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getDownloadLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setDownloadLink = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string close_link = 9;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.getCloseLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksRequest} returns this
 */
proto.no.jotta.openapi.GetLinksRequest.prototype.setCloseLink = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.no.jotta.openapi.GetLinksResponse.oneofGroups_ = [[100,101]];

/**
 * @enum {number}
 */
proto.no.jotta.openapi.GetLinksResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  LINKS: 100,
  DISABLED_BY_OWNER: 101
};

/**
 * @return {proto.no.jotta.openapi.GetLinksResponse.ResultCase}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getResultCase = function() {
  return /** @type {proto.no.jotta.openapi.GetLinksResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.no.jotta.openapi.GetLinksResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.GetLinksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.GetLinksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    links: (f = msg.getLinks()) && proto.no.jotta.openapi.GetLinksResponse.Links.toObject(includeInstance, f),
    disabledByOwner: (f = msg.getDisabledByOwner()) && proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.toObject(includeInstance, f),
    actionUrlDeprecated: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accessTokenDeprecated: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accessTokenTtlDeprecated: jspb.Message.getFieldWithDefault(msg, 3, 0),
    appNameDeprecated: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actionTypeDeprecated: jspb.Message.getFieldWithDefault(msg, 5, 0),
    resourceDeprecated: jspb.Message.getFieldWithDefault(msg, 6, ""),
    favIconUrlDeprecated: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.GetLinksResponse}
 */
proto.no.jotta.openapi.GetLinksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.GetLinksResponse;
  return proto.no.jotta.openapi.GetLinksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.GetLinksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.GetLinksResponse}
 */
proto.no.jotta.openapi.GetLinksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 100:
      var value = new proto.no.jotta.openapi.GetLinksResponse.Links;
      reader.readMessage(value,proto.no.jotta.openapi.GetLinksResponse.Links.deserializeBinaryFromReader);
      msg.setLinks(value);
      break;
    case 101:
      var value = new proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner;
      reader.readMessage(value,proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.deserializeBinaryFromReader);
      msg.setDisabledByOwner(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActionUrlDeprecated(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessTokenDeprecated(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccessTokenTtlDeprecated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppNameDeprecated(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.openapi.WopiActionType} */ (reader.readEnum());
      msg.setActionTypeDeprecated(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setResourceDeprecated(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavIconUrlDeprecated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.GetLinksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.GetLinksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinks();
  if (f != null) {
    writer.writeMessage(
      100,
      f,
      proto.no.jotta.openapi.GetLinksResponse.Links.serializeBinaryToWriter
    );
  }
  f = message.getDisabledByOwner();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.serializeBinaryToWriter
    );
  }
  f = message.getActionUrlDeprecated();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccessTokenDeprecated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccessTokenTtlDeprecated();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAppNameDeprecated();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActionTypeDeprecated();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getResourceDeprecated();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFavIconUrlDeprecated();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.GetLinksResponse.Links.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.GetLinksResponse.Links} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.Links.toObject = function(includeInstance, msg) {
  var f, obj = {
    actionUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accessToken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accessTokenTtl: jspb.Message.getFieldWithDefault(msg, 3, 0),
    appName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    actionType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    resource: jspb.Message.getFieldWithDefault(msg, 6, ""),
    favIconUrl: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.GetLinksResponse.Links;
  return proto.no.jotta.openapi.GetLinksResponse.Links.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.GetLinksResponse.Links} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActionUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccessTokenTtl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppName(value);
      break;
    case 5:
      var value = /** @type {!proto.no.jotta.openapi.WopiActionType} */ (reader.readEnum());
      msg.setActionType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setResource(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavIconUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.GetLinksResponse.Links.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.GetLinksResponse.Links} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.Links.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActionUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccessTokenTtl();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAppName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getActionType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getResource();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFavIconUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string action_url = 1;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getActionUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setActionUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string access_token = 2;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 access_token_ttl = 3;
 * @return {number}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getAccessTokenTtl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setAccessTokenTtl = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string app_name = 4;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getAppName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setAppName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional WopiActionType action_type = 5;
 * @return {!proto.no.jotta.openapi.WopiActionType}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getActionType = function() {
  return /** @type {!proto.no.jotta.openapi.WopiActionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.openapi.WopiActionType} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setActionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string resource = 6;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getResource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setResource = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fav_icon_url = 7;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.getFavIconUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse.Links} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.Links.prototype.setFavIconUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.prototype.toObject = function(opt_includeInstance) {
  return proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner}
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner;
  return proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner}
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Links links = 100;
 * @return {?proto.no.jotta.openapi.GetLinksResponse.Links}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getLinks = function() {
  return /** @type{?proto.no.jotta.openapi.GetLinksResponse.Links} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.GetLinksResponse.Links, 100));
};


/**
 * @param {?proto.no.jotta.openapi.GetLinksResponse.Links|undefined} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
*/
proto.no.jotta.openapi.GetLinksResponse.prototype.setLinks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 100, proto.no.jotta.openapi.GetLinksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.clearLinks = function() {
  return this.setLinks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.hasLinks = function() {
  return jspb.Message.getField(this, 100) != null;
};


/**
 * optional DisabledByOwner disabled_by_owner = 101;
 * @return {?proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getDisabledByOwner = function() {
  return /** @type{?proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner} */ (
    jspb.Message.getWrapperField(this, proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner, 101));
};


/**
 * @param {?proto.no.jotta.openapi.GetLinksResponse.DisabledByOwner|undefined} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
*/
proto.no.jotta.openapi.GetLinksResponse.prototype.setDisabledByOwner = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.no.jotta.openapi.GetLinksResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.clearDisabledByOwner = function() {
  return this.setDisabledByOwner(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.hasDisabledByOwner = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional string action_url_deprecated = 1;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getActionUrlDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setActionUrlDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string access_token_deprecated = 2;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getAccessTokenDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setAccessTokenDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 access_token_ttl_deprecated = 3;
 * @return {number}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getAccessTokenTtlDeprecated = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setAccessTokenTtlDeprecated = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string app_name_deprecated = 4;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getAppNameDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setAppNameDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional WopiActionType action_type_deprecated = 5;
 * @return {!proto.no.jotta.openapi.WopiActionType}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getActionTypeDeprecated = function() {
  return /** @type {!proto.no.jotta.openapi.WopiActionType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.no.jotta.openapi.WopiActionType} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setActionTypeDeprecated = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string resource_deprecated = 6;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getResourceDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setResourceDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fav_icon_url_deprecated = 7;
 * @return {string}
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.getFavIconUrlDeprecated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.no.jotta.openapi.GetLinksResponse} returns this
 */
proto.no.jotta.openapi.GetLinksResponse.prototype.setFavIconUrlDeprecated = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.no.jotta.openapi.WopiActionType = {
  UNKNOWN_ACTION_TYPE: 0,
  VIEW: 1,
  EDIT: 2,
  EDITNEW: 3,
  GETINFO: 4,
  EMBEDVIEW: 5,
  CONVERT: 6
};

/**
 * @enum {number}
 */
proto.no.jotta.openapi.WopiConsent = {
  WOPI_CONSENT_UNKNOWN: 0,
  WOPI_CONSENT_ACCEPTED: 1,
  WOPI_CONSENT_DECLINED: 2,
  WOPI_CONSENT_NOT_ANSWERED: 3
};

goog.object.extend(exports, proto.no.jotta.openapi);
